import axios from 'axios'
import defaultOptions from './defaultoption'

const cadastro = {
  cadastroClientePF(body) {
    return fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-fisicas`,
      {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }
    )
  },
  updatePF(params) {
    return fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-fisicas`,
      {
        method: 'PUT',
        headers: defaultOptions.headers,
        body: JSON.stringify(params)
      }
    )
  },
  cadastroClientePJ(body) {
    return fetch(
      `${process.env.REACT_APP_API_CLIENTES}` + 'clientes/pessoas-juridicas',
      {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }
    )
  },
  updatePJ(params) {
    return fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-juridicas`,
      {
        method: 'PUT',
        headers: defaultOptions.headers,
        body: JSON.stringify(params)
      }
    )
  },
  async validarReceitaFederal(body) {
    return axios
      .post(
        `${process.env.REACT_APP_API_CLIENTES}clientes/cnpj-receita-federal`,
        body
      )
      .catch((error) => {
        return error.response
      })
  }
}

export default cadastro
